<main id="main">
    <!-- ======= Breadcrumbs ======= -->
    <div class="breadcrumbs" data-aos="fade-in" >
        <div class="container">
            <h2 class="marathi-font" [innerHTML]="title" ></h2>
        </div>
    </div><!-- End Breadcrumbs -->

    <section id="testimonials1" >
        <div class="container" data-aos="fade-up">

            <!-- <div class="section-title pb-0">
                <h2>Read Online</h2>
                <p class="marathi-font" [innerHTML]="title"></p><br>
              </div> -->

              <app-accordion [items]="leelas" [loaderVisable]="inProgress" (searchText)="SearchText($event)" 
              [enableGlobalSearch]="true" [nextDataAvailable]="nextDataAvailable"></app-accordion>
        </div>
    </section>
</main>